<template>
  <Panel lineColor="var(--primary-color)" class="panel">
    <div class="container-panel">
      <h4 class="text-start">Integração com serviço de e-mail</h4>
      <LineDivider />

      <FormSwitch
        label="Habilitar envio de e-mails"
        v-model="emailHabilitado"
        class="mt-n3 mb-3"
      />

      <FormSelect
        label="Serviço"
        placeholder="Selecione um serviço"
        v-model="mailService"
        :options="mailServiceOptions"
        :disabled="!emailHabilitado"
      />

      <div v-if="mailService === 'ELASTIC_MAIL'">
        <FormField
          label="API Key"
          placeholder="API Key / Chave da API"
          v-model="elasticmail.apiKey"
          :disabled="!emailHabilitado"
        />

        <FormField
          label="Public Account ID"
          placeholder="Public Account ID"
          v-model="elasticmail.accountId"
          :disabled="!emailHabilitado"
        />
      </div>

      <div v-else-if="mailService === 'SMTP'">
        <FormField
          label="Host"
          placeholder="Host"
          v-model="smtp.host"
          :disabled="!emailHabilitado"
        />

        <FormField
          label="Porta"
          placeholder="Porta"
          v-model="smtp.port"
          :disabled="!emailHabilitado"
        />

        <FormField
          label="Usuário"
          placeholder="Usuário"
          v-model="smtp.user"
          :disabled="!emailHabilitado"
        />

        <FormField
          label="Senha"
          placeholder="Senha"
          v-model="smtp.password"
          :disabled="!emailHabilitado"
        />

        <FormField
          label="E-mail do remetente"
          placeholder="E-mail do remetente"
          v-model="smtp.sender"
          :disabled="!emailHabilitado"
        />

        <FormField
          label="Nome do remetente"
          placeholder="Nome do remetente"
          v-model="smtp.senderName"
          :disabled="!emailHabilitado"
        />

        <FormSwitch
          label="Usar conexão segura ssl/tls"
          v-model="smtp.secure"
          :disabled="!emailHabilitado"
        />
      </div>

      <a
        v-if="mailService === 'ELASTIC_MAIL' || mailService === 'SMTP'"
        :href="
          mailService === 'ELASTIC_MAIL' ? linkAjudaElastic : linkAjudaSMTP
        "
        target="_new"
        :class="{ 'link-desabilitado': !emailHabilitado }"
      >
        {{
          mailService === "ELASTIC_MAIL"
            ? "Ajuda com a integração de e-mail via ElasticMail"
            : "Ajuda com a integração de e-mail SMTP"
        }}
      </a>
    </div>
  </Panel>
</template>

<script>
import Panel from "@/components/Panel";
import LineDivider from "@/components/LineDivider";
import FormSelect from "@/components/form/FormSelect";
import FormField from "@/components/form/FormField";
import FormSwitch from "@/components/form/FormSwitch";

export default {
  components: {
    Panel,
    LineDivider,
    FormSelect,
    FormField,
    FormSwitch
  },
  props: {
    dados: {
      type: Object,
      default: function() {
        return {};
      },
      required: false
    }
  },
  emits: ["dataToParent"],
  data() {
    return {
      emailHabilitado: false,
      mailService: "",
      mailServiceOptions: [
        { text: "ElasticMail", value: "ELASTIC_MAIL" },
        { text: "SMTP", value: "SMTP" }
      ],
      elasticmail: {
        apiKey: "",
        accountId: ""
      },
      smtp: {
        host: "",
        port: "",
        user: "",
        password: "",
        sender: "",
        senderName: "",
        secure: true
      },
      linkAjudaElastic:
        "https://lifeapps.atlassian.net/wiki/spaces/BC/pages/26673987/Como+criar+modelos+de+e-mail+templates",
      linkAjudaSMTP:
        "https://lifeapps.atlassian.net/wiki/spaces/BC/pages/26936316/Envio+de+e-mail+usando+o+SMTP"
    };
  },
  watch: {
    dados: {
      deep: true,
      handler(newVal, oldVal) {
        if (!newVal) {
          return;
        }
        this.fornecedor = newVal.fornecedor;
        this.areavenda = newVal.areavenda;
        if (
          newVal.emailHabilitado !== undefined &&
          (!oldVal || newVal.emailHabilitado !== oldVal.emailHabilitado)
        ) {
          this.emailHabilitado = newVal.emailHabilitado;
        }
        if (
          newVal.mailService !== undefined &&
          (!oldVal || newVal.mailService !== oldVal.mailService)
        ) {
          this.mailService = newVal.mailService || "";
        }
        if (newVal.smtp && (!oldVal || newVal.smtp !== oldVal.smtp)) {
          this.smtp = newVal.smtp;
        }
        if (
          newVal.elasticmail &&
          (!oldVal || newVal.elasticmail !== oldVal.elasticmail)
        ) {
          this.elasticmail = newVal.elasticmail;
        }
      }
    },
    emailHabilitado: {
      handler(newVal) {
        this.$emit("dataToParent", {
          evento: "emailHabilitado",
          dados: newVal
        });
      }
    },
    mailService: {
      deep: true,
      handler(newVal) {
        this.$emit("dataToParent", { evento: "mailService", dados: newVal });
      }
    },
    elasticmail: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.$emit("dataToParent", { evento: "elasticmail", dados: newVal });
        }
      }
    },
    smtp: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.$emit("dataToParent", { evento: "smtp", dados: newVal });
        }
      }
    }
  }
};
</script>

<style scoped>
a {
  color: #337ab7 !important;
  font-size: 12px !important;
  display: block;
  text-align: left;
  text-decoration: none;
}

a.link-desabilitado {
  opacity: 0.5;
  pointer-events: none;
}

.panel {
  margin-top: 30px;
}

.panel .container-panel {
  padding: 0;
}
</style>
